import { HStack, Text, useTheme, VStack } from '@chakra-ui/react';
import { cloneElement, useMemo } from 'react';
import { Link } from 'react-router-dom';

export interface IBottomMenuLink {
  name: string;
  icon: JSX.Element;
  path: string;
  desktopName?: string;
  hide?: boolean;
}

function BottomMenuLink({ link }: { link: IBottomMenuLink }) {
  const { colors } = useTheme();
  const isActive = useMemo(() => window.location.pathname === link.path, [link]);

  return (
    <Link style={{ minWidth: 50, cursor: 'pointer' }} to={link.path}>
      <VStack key={link.name} spacing={0}>
        {cloneElement(link.icon, {
          transition: '0.2s',
          width: 27,
          height: 27,
          color: isActive ? colors.primaryColor : '#747474',
        })}
        <Text textAlign={'center'} whiteSpace={'nowrap'} transition={'0.2s'} color={isActive ? 'primaryColor' : '#747474'} fontWeight={'500'} fontSize={'12px'}>
          {link.name}
        </Text>
      </VStack>
    </Link>
  );
}

export function BottomMenu({ isIframeActive, links }: { isIframeActive?: boolean, links: IBottomMenuLink[] }) {
  const { isIOS } = useTheme();
  return (
    <HStack
      display={{ base: 'flex', lg: 'none' }}
      justify={'space-around'}
      align={'center'}
      position={'fixed'}
      bottom="0px"
      left={'0px'}
      right={'0px'}
      backgroundColor={'rgba(255,255,255,0.95)'}
      boxShadow="rgba(17, 12, 46, 0.3) 0px 48px 100px 0px"
      backdropFilter={'blur(5px)'}
      padding="10px"
      zIndex={200}
      pointerEvents={isIframeActive ? 'none' : 'auto'}
      paddingBottom={isIOS ? '30px' : '10px'}
    >
      {links.map((l, i) => (
        <BottomMenuLink key={i} link={l} />
      ))}
    </HStack>
  );
}
